class ImperiaPdpGallery extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-gallery-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-media-panel]'));
    this.secondaryMedia = Array.from(this.querySelectorAll('[data-secondary-media]'));
    this.index = this.querySelector('[data-media-index]');
    this.variantSelect = this.querySelector('[data-variant-select]');

    this.triggers.forEach((trigger) => trigger.addEventListener('click', this.handleGalleryClick));
    this.variantSelect?.addEventListener('change', this.handleVariantChange);
  }

  disconnectedCallback() {
    this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.handleGalleryClick));
    this.variantSelect?.removeEventListener('change', this.handleVariantChange);
  }

  handleGalleryClick = (event) => {
    const activeIndex = Number(event.currentTarget.dataset.galleryTrigger);

    this.triggers.forEach((trigger, index) => {
      trigger.setAttribute('aria-pressed', String(index === activeIndex));
    });
    this.panels.forEach((panel, index) => {
      panel.hidden = index !== activeIndex;
    });
    this.secondaryMedia.forEach((media, index) => {
      media.hidden = index === activeIndex;
    });

    if (this.index) this.index.textContent = `${String(activeIndex + 1).padStart(2, '0')} / 02`;
  };

  handleVariantChange = (event) => {
    const option = event.currentTarget.selectedOptions[0];
    const available = option?.dataset.available === 'true';
    const price = this.querySelector('[data-product-price]');
    const availability = this.querySelector('[data-product-availability]');
    const button = this.querySelector('[ref="addToCartButton"]');
    const buttonText = button?.querySelector('.add-to-cart-text__content');

    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    if (availability) availability.textContent = available ? 'DISPONIBLE ONLINE' : 'AGOTADO';
    if (button) button.disabled = !available;
    if (buttonText) buttonText.textContent = available ? 'AGREGAR AL CARRITO' : 'AGOTADO';
  };
}

if (!customElements.get('imperia-pdp-gallery')) {
  customElements.define('imperia-pdp-gallery', ImperiaPdpGallery);
}
